import { authorizedInstance } from "../config/axios"
import { buildQueryString } from "../utils"

export const getMissingPathologyCounts = async ({ filters = {} } = {}) => {
  const query = buildQueryString({ ...filters })
  const response = await authorizedInstance.get(
    `/missing-pathology-logs/counts?${query}`
  )
  return response.data
}

export const getMissingPathologyTerms = async ({
  page = 1,
  limit = 20,
  sortBy = "UpdatedAt:DESC",
  filters = {},
}) => {
  const query = buildQueryString({
    page,
    limit,
    sortBy,
    ...filters,
  })
  const response = await authorizedInstance.get(
    `/missing-pathology-logs?${query}`
  )
  return response.data
}

export const getMissingPathologyLogsByTerm = async ({
  pathologyTermMappingId,
  page = 1,
  limit = 20,
  sortBy = "createdAt:DESC",
  filters = {},
}) => {
  const query = buildQueryString({
    page,
    limit,
    sortBy,
    ...filters,
  })
  const response = await authorizedInstance.get(
    `/missing-pathology-logs/by-term/${pathologyTermMappingId}?${query}`
  )
  return response.data
}

export const getCanonicalNames = async ({
  BodyPart,
  search,
  includeInactive,
} = {}) => {
  const query = buildQueryString({
    BodyPart,
    search,
    includeInactive,
  })
  const response = await authorizedInstance.get(
    `/missing-pathology-logs/canonical-names?${query}`
  )
  return response.data
}

export const updatePathologyTermMapping = async ({
  pathologyTermMappingId,
  Status,
  PathologyMappingId,
  Notes,
}) => {
  const body = { Status }
  if (Status === "MAPPED") {
    body.PathologyMappingId = PathologyMappingId
    const trimmed = typeof Notes === "string" ? Notes.trim() : ""
    if (trimmed) body.Notes = trimmed
  }
  const response = await authorizedInstance.patch(
    `/missing-pathology-logs/term/${pathologyTermMappingId}`,
    body
  )
  return response.data
}

export const getMissingPathologyLogByLogId = async (missingPathologyLogId) => {
  const response = await authorizedInstance.get(
    `/missing-pathology-logs/log/${missingPathologyLogId}`
  )
  return response.data
}

export const getDistinctBodyParts = async () => {
  const response = await authorizedInstance.get(
    `/missing-pathology-logs/body-parts`
  )
  return response.data
}
